import { SUPPLIES_NEEDED } from '../../constants';

const initialState = {
  data: [],
  loading: true,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case SUPPLIES_NEEDED.LOAD:
      return {
        ...state,
        loading: true
      };
    case SUPPLIES_NEEDED.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case SUPPLIES_NEEDED.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
